'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = require('../events');

var _events2 = _interopRequireDefault(_events);

var _accounts = require('../accounts');

var _accounts2 = _interopRequireDefault(_accounts);

var _getFeisAge = require('ifeis-isomorphic/lib/utilities/getFeisAge');

var _getFeisAge2 = _interopRequireDefault(_getFeisAge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.registrations', ['ifeis.events', 'ifeis.accounts']).factory('fRegistrationService', function ($http, fEventService, fAccountService) {
  var feis_prefix = IFEIS_API_URI + '/api/feiseanna';
  var account_prefix = IFEIS_API_URI + '/api/accounts';

  function deserialize(reg) {
    reg.event = fEventService.deserializeEvent(reg.event);
    return reg;
  }

  /**
   * Registrations for a Person-Feis
   */
  function PersonRegistrations(fid, pid) {
    this.fid = fid;
    this.pid = pid;
    this.prefix = feis_prefix + '/' + fid + '/registrations/' + pid;
  }

  PersonRegistrations.prototype.create = function (event_id) {
    return $http.post(this.prefix, { event_id: event_id }).then(deserialize);
  };

  PersonRegistrations.prototype.all = function () {
    return $http.get(this.prefix).then(function (regs) {
      return regs.map(deserialize);
    });
  };

  PersonRegistrations.prototype.delete = function (id) {
    return $http.delete(this.prefix + '/' + id);
  };

  PersonRegistrations.prototype.setNumber = function (number) {
    return $http.put(this.prefix, { num: number });
  };

  /**
   * Registration History for a Feis
   */

  function RegistrationHistory(fid) {
    this.fid = fid;
  }

  RegistrationHistory.prototype.one = function (pid) {
    return $http.get(account_prefix + '/persons/' + pid + '/feiseanna/' + this.fid + '/registrations');
  };

  RegistrationHistory.prototype.all = function (aid) {
    return $http.get(account_prefix + '/' + aid + '/feiseanna/' + this.fid + '/registrations');
  };

  /**
   * Registrations for a Feis
   */
  function Registrations(id) {
    this.fid = id;
    this.prefix = feis_prefix + '/' + id + '/registrations';
  }

  Registrations.prototype.for = function (pid) {
    return new PersonRegistrations(this.fid, pid);
  };

  Registrations.prototype.history = function () {
    return new RegistrationHistory(this.fid);
  };

  Registrations.prototype.all = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return $http.get(this.prefix, { params: params });
  };

  /**
   * Exported API
   */

  return {
    for: function _for(id) {
      return new Registrations(id);
    },
    getFeisAge: _getFeisAge2.default
  };
});


//////////////////
// WEBPACK FOOTER
// ./registrations/index.js
// module id = 63
// module chunks = 0